import React from 'react';
import { useLooseTreatments } from '../hooks/useLooseTreatments';
import { getCurrentLocale } from '../services/api';

const LooseTreatmentsSection: React.FC = () => {
  const { data, loading } = useLooseTreatments();
  const locale = getCurrentLocale();

  // Default content when no Strapi data is available
  const defaultData = {
    title: locale === 'ar' ? 'علاجات منفصلة' : 'Losse behandelingen',
    items: [
      {
        id: 1,
        name:
          locale === 'ar'
            ? 'استشارة + تحليل فروة الرأس التريكولوجي'
            : 'Intake + trichologische hoofdhuidanalyse',
        description:
          locale === 'ar'
            ? 'تحليل شامل لفروة الرأس وبصيلات الشعر'
            : 'Uitgebreide analyse van de hoofdhuid en haarfollikels',
        price: '€125',
      },
    ],
  };

  if (loading) {
    return (
      <section className="loose-treatments-section">
        <div className="loading-placeholder">
          <div className="loading-title">Loading...</div>
        </div>
      </section>
    );
  }

  // Use Strapi data if available, otherwise use default data
  const content = data || defaultData;

  return (
    <section className="loose-treatments-section">
      <div className="loose-treatments-container">
        <h2 className="section-title">
          {content.title}
        </h2>

        <div className="treatments-list">
          {(content.items || []).map((treatment) => (
            <div key={treatment.id} className="treatment-item">
              <div className="treatment-name">{treatment.name}</div>
              <div className="treatment-price">{treatment.price}</div>
            </div>
          ))}
        </div>

        {content.description && (
          <p className="treatment-description">{content.description}</p>
        )}
      </div>
    </section>
  );
};

export default LooseTreatmentsSection; 